// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2O-9o","choiceBoxes":"toolbarselects_choiceBoxes__20wkT","simpleField":"toolbarselects_simpleField__QeG2_"};